import styled from '@emotion/styled';
import ContentWrapper from '../../components/ContentWrapper';
import screenSizes from '../../constants/screenSizes';
import { colors } from '../../constants/colors';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router';
import ServiceCardItem from './ServiceCardItem';
import ServiceItem from './ServiceItemNew';
import HomeHeader from '../../components/site-header/HomeHeader';

const defaultService = [
  {
    id: 5,
    title: 'UNOSAT AI',
    description:
      'UNOSAT has years of mapping experience analyzing satellite imagery in support of the UN and member states all over the world. Considering the large data library and analyses published throughout the years, UNOSAT has emerged as a primary partner for organizations wishing to explore Artificial Intelligence (AI) for humanitarian applications. In particular, the vast collection of vector data, UNOSAT has developed over the years, have proven extremely useful as training datasets for AI and related development. UNOSAT is designing, developing, and deploying deep learning models applied to satellite imagery for humanitarian assistance and disaster response such as flood analysis, shelter mapping, building footprints, damage assessment, and more. UNOSAT integrated the AI models into end-to-end pipeline that downloads and processes satellite imagery in Near-Real-Time, bringing the power of AI directly in the hands of the users. \r\nRecent advancements in AI and the increasing availability of satellite images allowed geospatial analysts to accurately process big data in a short time expanding the coverage and the number of events UNOSAT can address. Thanks to these advancements, the analysts can work at scale rather than at capacity. Turning AI into concrete applications for mapping is possible thanks to CERN’s IT infrastructure and the collaborations with renowned institutions and partners such as CERN Openlab, UN Global Pulse,  Wuhan University, and NVIDIA.',
    icon: '/static/unosat_filesystem/services/SERVICES_UNOSAT%20AI_BLUE_ICON.svg',
    image_file: '/static/unosat_filesystem/services/UNOSAT%20AI%20(2).jpg',
    subtitles: [
      'Fully operational in the mapping services, UNOSAT FloodAI is an end-to-end pipeline, developed in collaboration with UN Global Pulse, where Sentinel-1 radar images of flood-prone areas are automatically downloaded and processed by machine learning algorithms to output flood vector data and update operational dashboards.',
      'UNOSAT is conducting research to expand its end-to-end pipeline to perform building damage assessments resulting from natural disasters and conflict using very high-resolution satellite imageries. This project is in collaboration with CERN Openlab.',
      'If you are looking to test and deploy your machine learning model into humanitarian operational settings, please contact us at unosat@unitar.org.',
    ],
  },
  {
    id: 2,
    title: 'Capacity Development',
    description:
      'UNOSAT has over 20 years of practical experience in the design, development and delivery of tailor-made geospatial services and learning solutions for UN agencies, funds and programmes, as well as Member States, other international organizations and academia. By leveraging science and innovative technologies, countries will have better tools and solutions to inform policies, planning and decision making. It is very important to develop technical capacities and to establish robust and predictable mechanisms to access datasets and open data platforms. Capacity development and training are therefore essential functions of UNOSAT to promote evidence-based decision making for peace, security and resilience.\r\nThe learning solutions developed by UNOSAT aim to make satellite solutions and the use of Geospatial Information Technologies (GIT) enabling and easily accessible to the participants. The activities can relate to specific GIT applications, such as Disaster Risk Reduction (DRR), climate resilience, preservation of cultural and natural heritage or the protection of Human Rights. There is also a strong effort to enhance the capacity of disaster management authorities to use geospatial applications for disaster preparedness and response.',
    icon: '/static/unosat_filesystem/services/SERVICES_CAPACITY%20DEVELOPMENT_BLUE_ICON.svg',
    image_file: '/static/unosat_filesystem/services/Capacity%20Development%20V1-02.jpg',
    subtitles: [
      'Expertise in-designing and delivery innovative blended learning solutions : on the use of GIT to different application domains including the know-how of using scientific information and spatial datasets into decision support products.',
      'Strong partnerships : with academia, private sectors and innovators helps us to develop learning material and training contents with bleeding edge technologies.',
      'Technical backstopping : from comprehensive risk analysis to modern web mapping systems and Operations Dashboards, various products can be developed to support informed decision making. These mini geospatial projects help improve or optimise existing operations. \r\nRobust Quality Assurance Framework: all learning-related events are assessed against a set of over a dozen standards prior to delivery in accordance with the Institute’s Quality Assurance Framework to facilitate certification with external quality schemes, such as the e-Learning programmes and institutions in international capacity building (ECBCheck) certification process.',
      'In-country national expert : the bridge between the technical team and the beneficiary ministry. They work on-site and hand-in-hand with the partner for the implementation of activities.',
    ],
  },
  {
    id: 4,
    title: 'Peace and Security',
    description:
      'UNOSAT has long supported UN agencies and programmes involved in peace and security, including Offices of Special Envoys (OSEs), the UN Operations and Crisis Centre (UNOCC), and various UN missions and country offices. UNOSAT provides advanced geospatial support to partners in need of regular updates for critical areas and situations. \r\nThe objectivity and relevance of the information derived from satellite imagery allows the partners to have a more comprehensive understanding of the situation. This identification and documentation, in areas inaccessible to field missions, in near real time is a big advantage. UNOSAT provides high-quality satellite-derived analyses that can include identification of the location and severity of damage according to the partner’s needs.\r\nFor example, UNOSAT has monitored critical border areas and incursion areas, assessed damage from major international conflicts, monitored populations movements, accessibility status, including for humanitarian corridors, analysed information on possible arms embargo violations, reviewed ports and airports, and more.',
    icon: '/static/unosat_filesystem/services/SERVICES_PEACE%20%26%20SECURITY_BLUE_ICON.svg',
    image_file: '/static/unosat_filesystem/services/Peace%20and%20Security-02.png',
    subtitles: [],
  },
  {
    id: 6,
    title: 'DRR and Climate Resilience',
    description:
      'Reducing disaster risk and adapting to a changing climate have become increasingly critical for achieving sustainable development. The need to combine practical and actionable risk reduction and climate resilience efforts with innovative technology and capacity development will be increasingly important going forward.   \r\n\r\nThe international community devises ways to scale up current efforts and develop solutions that are more effective to bridge the humanitarian, development and climate sectors, and capture synergies across risk reduction, early warning systems, preparedness, response and recovery related policies and interventions.\r\n\r\nBy leveraging science and innovative technologies such as Earth Observation (EO), Artificial Intelligence (AI), Machine Learning, and Big Data Analytics countries will have better decision support tools and solutions to inform policies, planning, and decision making. It is therefore very important to build technical capacities and to establish robust, evidence-based, and predictable mechanisms to access datasets and open data platforms that will enable member states to achieve sustainable development.\r\nOur team has more than a decade of remarkable practical experience in the design, development, and delivery of innovative and tailor-made geospatial services and learning solutions for improved Disaster Risk Reduction (DRR) and Climate Resilience. To know more, consult the page on Capacity Development [LINK].\r\nUNOSAT also supports national disaster risk management authorities by developing innovative GIS-based applications and decision support platforms to bridge science-policy gaps and to allow decision-makers to understand the spatial distribution of risk at both the national and subnational levels. The use of geospatial platforms and GIS-based applications are increasingly used by governments, international and regional organizations, the private sector, and the general public in many different application domains. For example, by seamless access to custom-tailored decision support platforms, planners and decision-makers can access contextual analysis of a variety of hazards, risks and vulnerability, and socio-economic indicators for improved risk knowledge and early action under a changing climate.',
    icon: '/static/unosat_filesystem/services/Multi-Hazard%20white%20circle.png',
    image_file: '/static/unosat_filesystem/services/Drr%20and%20climate.jpg',
    subtitles: [
      'Through GIS-based applications and decision support platforms, users can more easily understand the terminology, complex scientific analytics, and limitations associated with risk and climate-related data.',
      'We promote and enable access to free and open data services including EO-derived risk and climate-related datasets for hazard-specific or multi-hazard risk assessment, early warning, and impact-based forecasting.',
    ],
  },
  {
    id: 7,
    title: 'Project Monitoring & Evaluation',
    description:
      'The use of Earth Observation extends partners’ capacities to monitor development projects of different scales as it provides regular and unbiased updates. Multiple regions with the construction of new roads, wells, facilities, or other infrastructure can be observed remotely at once using satellite imagery. Geospatial data provide consistent, timely, and reliable information from which project managers assess progress. Satellite imagery can also support the impact evaluation by analysing transformations in the location where the project took place and its surrounding areas. Long-tern outcomes can be assessed by combining image analysis and georeferenced datasets from before, during, and after implementation.\r\nUNOSAT has been collaborating with development agencies and banks in many countries to develop web-based monitoring solutions that allow the user to visualize the satellite-derived analysis combined with other data. These innovative tools can be integrated within the partners existing monitoring systems and tailored to their needs. Thanks to the combination of geospatial analysis with field information, partners have been able to better plan and reduce the frequency of costly verification missions. The tools also support communication on project results to various stakeholders and reporting to donors.',
    icon: '/static/unosat_filesystem/services/project%20monitoring%20white%20circle.png',
    image_file: '/static/unosat_filesystem/services/ProjectMonitoring.png',
    subtitles: [
      'The web-based solutions developed are a one-stop shop for monitoring the areas of interest: from planning to progress and impact evaluation.',
      'Satellite imagery analysis for project monitoring helps reduce and better plan expensive field missions.',
      'Earth observation is recognized as an objective technology, it allows partners to have a more ethical and transparent approach when reporting on development projects.',
      'For a more comprehensive picture of the project,  we offer partners mobile solutions for on-site georeferenced images that can be uploaded in real-time.',
    ],
  },
  {
    id: 3,
    title: 'Human Rights',
    description:
      'Geospatial Information Technologies (GIT) are powerful tools to gather objective information on remote locations. This makes it particularly efficient when it comes to monitoring the evolution of a conflict situation and documenting human rights violations. Thanks to its expertise, UNOSAT has been providing support to UN agencies and other International Organizations in investigations, fact finding missions, courts, and emergency response efforts concerned with violations of international humanitarian law. This has followed the guidance of the partner organization to discover and analyse satellite imagery and other relevant data that can help inform their work.\r\nUNOSAT’s support to human rights investigations consists of advanced geospatial support, the provision of high quality analyses, utilizing satellite imagery as evidence, and other support as needed, including testimonies.\r\nFor example, UNOSAT has long worked to support the Office of the UN High Commissioner for Human Rights (OHCHR), the International Criminal Court (ICC), the United Nations Educational, Scientific and Cultural Organization (UNESCO), the Independent Investigative Mechanism for Myanmar (IIMM), and other entities using satellite imagery analysis. This has included reporting on destruction to housing in cities, towns, and rural areas, position and disposition of weaponry and forces, graves, detention facilities, cultural heritage sites, and much more.',
    icon: '/static/unosat_filesystem/services/SERVICES_HUMAN%20RIGHT_BLUE_ICON.svg',
    image_file: '/static/unosat_filesystem/services/Human%20Rights.jpg',
    subtitles: [
      'For justice, UNOSAT has supported the International Criminal Court (ICC) with monitoring and analytical capacity in six cases since 2002, including expert testimony for four of them. Support is also provided to investigative mechanisms such as the IIMM.',
      'For the protection of cultural heritage, UNOSAT has a strong partnership with the United Nations Educational, Scientific and Cultural Organization (UNESCO). The satellite imagery analysis provided help to document the state of cultural heritage sites in multiple countries.',
      'For human rights, UNOSAT has long worked to support the Office of OHCHR with technical expertise and services, including satellite imagery analysis, field data collection, mapping, data management and training. In parallel to the service provision, many activities were jointly organized to raise awareness and technical capacity in the use of Geospatial Information Technology (GIT) for damage assessment.',
    ],
  },
  {
    id: 1,
    title: 'Emergency Mapping',
    description:
      'The increase in disaster occurrences and the high numbers of victims resulting from conflicts are urgent issues that require effective and rapid action. Satellite imagery analysis is a vital tool essential in this response, as it can cover large areas and provide accurate information in near real time. \r\nOperational since 2003, UNOSAT’s Emergency Mapping service provides satellite image analysis during humanitarian emergencies related to disasters, complex emergencies and conflict situations. With a 24/7 year-round availability to process requests, the team of experienced analysts ensure timely and tailored delivery of satellite imagery derived maps (both web and static maps), reports and data ready for direct inclusion in Geographic Information Systems (GIS) for evidence based decision making and operational planning. \r\nThe ability of national and regional authorities to seamlessly collect, integrate and analyze geospatial information in a comprehensible and easy to use format is key to enhancing their climate resilience. The products from UNOSAT’s Emergency Mapping service play a large role in this integration for local and regional authorities and are key to strengthening disaster and climate resilience, supporting humanitarian action and sustainable development policies.',
    icon: '/static/unosat_filesystem/services/Emergency%20Mapping%20Icon%20-%202022%20GEO%20SDG%20AWD.png',
    image_file: '/static/unosat_filesystem/services/Emergency%20Mapping%20(1).jpg',
    subtitles: [
      '24/7 on-call service for UN member states, UN agencies, Red Cross and Red Crescent Movement (ICRC and IFRC), international and regional organizations and humanitarian non-governmental organizations',
      'The service is free of charge for UN agencies and humanitarian entities operating in line with UN policies.',
    ],
  },
];

const MainContainer = styled.div`
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
`;

const Content = styled.div`
  padding: 120px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(144, 165, 185, 1);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media (min-width: ${screenSizes.medium.min}) {
    padding: 120px 20px 80px;
  }

  @media (min-width: ${screenSizes.large.min}) {
    padding: 200px 80px 100px;
  }
`;

const Section = styled.section`
  background: rgba(144, 165, 185, 1);
  width: 100%;
`;

const Description = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 20px;
  font-weight: 500;
  text-align: left;
  line-height: 1.6;
  margin-top: 20px;
  width: 100%;

  @media (min-width: ${screenSizes.medium.min}) {
    font-size: 24px;
  }

  @media (min-width: ${screenSizes.large.min}) {
    font-size: 28px;
    line-height: 1.3;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;

  @media (min-width: ${screenSizes.medium.min}) {
    padding: 0 40px;
  }

  @media (min-width: ${screenSizes.large.min}) {
    padding: 0 80px 100px;
  }
`;

const ServiceWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;

const Title = styled.h1`
  font-size: 36px;
  width: 100%;
  font-weight: 900;
  color: white;
  text-align: left;
  margin: 0;

  @media (min-width: ${screenSizes.medium.min}) {
    font-size: 48px;
  }

  @media (min-width: ${screenSizes.large.min}) {
    font-size: 56px;
  }
`;

const WrapperBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 20px;
  width: 100%;
`;

const ServiceNew = () => {
  const history = useHistory();
  const [services, setServices] = useState(null);
  const selectedService = history?.location?.state?.selectedService;

  useEffect(() => {
    axios
      .get('/our_services')
      .then((response) => {
        setServices(response?.data);
      })
      .catch((error) => {
        console.log(error);
        setServices(defaultService);
      });
  }, []);

  const visibleServiceItem = services?.find((service) => service.title === selectedService);

  return (
    <MainContainer>
      <HomeHeader />
      <Content>
          <Title>UNOSAT Services</Title>
          <Description>
            UNOSAT provides comprehensive geospatial analysis services to UN agencies and Member
            States. Discover our full range of services here:
          </Description>
      </Content>
      <Section>
        <Wrapper>
          <WrapperBox>
            {services &&
              services.map(({ icon, title }, index) => (
                <ServiceCardItem
                  key={`service-${index}`}
                  icon={icon}
                  title={title}
                  selectedService={selectedService}
                />
              ))}
          </WrapperBox>
        </Wrapper>
      </Section>
      {visibleServiceItem && (
        <ServiceWrapper>
          <ServiceItem {...visibleServiceItem} />
        </ServiceWrapper>
      )}
    </MainContainer>
  );
};

export default ServiceNew;
